import {http, httpAuth} from './config';

export default {
    register: user => httpAuth.post('v1/oauth/register', user),

    security: token => httpAuth.get(`v1/security/login/${token}`),

    login: user => httpAuth.post('v1/oauth/token', user),

    loadSession: token => httpAuth.get('v1/oauth/check', token),

    refreshToken: token => httpAuth.post('v1/oauth/refresh', token),

    google: googleUser => httpAuth.get('login/google/callback', {params: googleUser}),

    listRealtor: allotmentId => http.get(`api/v1/loteamentos/corretores/${allotmentId}`),

    permissions: allotmentId => http.get(`api/v1/usuarios/permissao/${allotmentId}`),

    create: user => http.post('api/v1/usuarios', user),

    createPublic: (user, allotmentId, token) => http.post('api/v1/publica/usuario', user, {
        headers: {
            'allotment-id': allotmentId,
            token: token,
        },
    }),

    show: userId => httpAuth.get(`v1/usuarios/${userId}`),

    update: user => http.put(`api/v1/usuarios/dados-pessoais/${user.id}`, user),

    showByCompanyWithoutPaginate: companyId => httpAuth.get(`v1/oauth/showPorEmpresa/${companyId}`),

    showByCompany: (companyId, filter, page = 1) => httpAuth.get(`v1/usuarios/companhia/${companyId}`, {
        params: {
            'filtro': filter,
            page,
        },
    }),

    recoverPassword: email => httpAuth.post('v1/password/email', email),

    resetPassword: password => httpAuth.post('v1/password/reset', password),

    resetPasswordLogged: dates => httpAuth.post('v1/usuarios/reset/password', dates),

    sendEmailRegister: email => httpAuth.post('v1/password/email/first', email),

    listPhoneType: () => httpAuth.get('v1/usuarios/tipoTelefones'),

    listAll: () => http.get('api/v1/usuarios'),

    validateToken: (token, mail) => httpAuth.post('v1/password/reset/validate-token', {token: `${token}/${mail}`}),

    validateTokenPublicUser: (token, allotmentId) => http.post('api/v1/publica/usuarios/checklinkpublico', {}, {
        headers: {
            token: token,
            'allotment-id': allotmentId,
        },
    }),

    import: (file, allotment_id, notify = false) => {
        const formData = new FormData();
        formData.append('file', file);
        return http.post('api/v1/importar/usuarios', formData, {
            headers: {
                'allotment-id': allotment_id,
                'Content-Type': 'multipart/form-data',
                notify,
            }
        });
    },

    exportUsersAlotment: allotmentId => http.get(`api/v1/exportar/corretores/${allotmentId}`, {responseType: 'blob'}),
}
